import HandIcon from './component.jsx'
export default HandIcon
